<template>
  <div>
    <Loader v-if="!!showLoader"></Loader>
    <div v-if="emailupdated">
      <div class="confirmation__icon"></div>
      <p>
        <span class="font-thick mt-2">Din e-postadress är nu ändrad.</span><br />
        Nästa gång du loggar in på Mina sidor får du ett e-postmeddelande till den e-postadress du nu angett ({{ updateObj.email }}).<br />
        I det meddelandet finns en sexsiffrig kod som du ska ange för att bekräfta din nya e-postadress.
      </p>

        <p class="mt-3 flex items-center">
          <Button type="primary"  id="save" href="/mina-sidor">Logga in på Mina sidor</Button>
        </p>
    </div>


    <div v-else>
      <div v-if="primaryEmailIsInUse">
        <p>
          Din e-postadress
          <span>{{ originalEmail }}</span>
          används på flera konton. Dessa användare har angivit samma e-post:
        </p>
        <div v-if="emailNames && emailNames.length > 0">
          <ul>
            <li v-for="name in emailNames">{{ name }}</li>
          </ul>
        </div>
      </div>
      <div v-if="!email">
        <p>Det finns ingen e-postadress angiven till ditt konto på Mina sidor.</p>
      </div>
      <form @submit.prevent="submit()">
        <div class="form-group">
          <p :class="{ control: true }">
            <Input
              id="email"
              label="Ange en ny unik e-postadress"
              v-model="updateObj.email"
              type="text"
              placeholder="E-postadress"
              :floatingLabel="true"
              required
            />
          </p>

          <div v-if="dataobj && (dataobj.postalAddress == null || (dataobj.zipCode == null || dataobj.zipCode.length != 5) || dataobj.city == null)">
            <p class="mt-4 font-bold">Vi saknar några uppgifter</p>
            <p v-if="dataobj.postalAddress == null" :class="{ control: true }">
              <Input
                id="postalAddress"
                label="Adress"
                v-model="updateObj.postalAddress"
                type="text"
                placeholder="Adress"
                :floatingLabel="true"
                required
              />
            </p>

            <p v-if="dataobj.zipCode == null || dataobj.zipCode.length != 5" :class="{ control: true }" class="mt-1">
              <Input
                id="zipCode"
                label="Postnummer"
                v-model="updateObj.zipCode"
                type="text"
                maxlength="5"
                placeholder="Postnummer"
                :floatingLabel="true"
                required
              />
            </p>

            <p v-if="dataobj.city == null" :class="{ control: true }" class="mt-1">
              <Input
                id="city"
                label="Ort"
                v-model="updateObj.city"
                type="text"
                placeholder="Ort"
                :floatingLabel="true"
                required
              />
            </p>
          </div>
        </div>

        <div v-if="this.errormsg">
          <p class="mt-2">
            {{this.errormsg}}
          </p>

        </div>

        <div class="mt-3">
          <Button id="save" type="submit">Spara</Button>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

import Loader from '@/components/ui/loader';
import Button from '@/components/ui/button';
import Input from '@/components/ui/form/input';

export default {
  components: { Loader, Button, Input },
  props: ['email', 'code', 'dataobj', 'forbiddenMessage'],
  data() {
    return {
      errormsg: null,
      originalEmail: null,
      showLoader: false,
      emailupdated: false,
      updateObj: {
        email: this.email,
        zipCode: this.dataobj.zipCode,
        postalAddress: this.dataobj.postalAddress,
        city: this.dataobj.city
      },
    };
  },

  computed: {
    ...mapGetters({
      primaryEmailIsInUse: 'primaryEmailIsInUse',
      emailNames: 'emailNames',
    }),
  },

  mounted() {
    this.originalEmail = this.email;
  },

  methods: {
    submit() {
      const self = this;
      this.errormsg = null;
      this.showLoader = true;

          return this.$store
            .dispatch('updateEmail', {
              ...self.credentials,
              code: self.code,
              email: this.updateObj.email,
              city: this.updateObj.city,
              postalAddress: this.updateObj.postalAddress,
              zipCode: this.updateObj.zipCode,
            })
            .then(() => {
              this.$emit('emailUpdated');
              this.emailupdated = true;
              this.showLoader = false;
            })
            .catch((err) => {
              const description = err?.response?.data?.description;

              if (description === "Email already in use") this.errormsg = "E-postadressen används redan på ett annat konto. Vänligen ange en unik e-postadress."
              else this.errormsg = "Något gick fel, försök igen";
              this.showLoader = false;
              throw err;
            });
    },
  },
};
</script>

<style scoped lang="scss">
.help {
  color: #ff0800;
  font-size: 14px;
}


label {
  font-size: 1.8rem;
  font-weight: 400;
  margin-bottom: 1.6rem;
  display: block;
  text-align: left;
  text-transform: none;
}

.btnRow {
  .btn {
    margin: 16px 0;
  }
}

input[type=text] {
  width: 100%;
  margin-top: 7px;
  margin-bottom: 8px;
  padding: 7.5px 10px;
  background: #fff;
  border: 1px solid #757575;
  font-size: .9em;
  line-height: 1.6;
  outline: none;
  box-shadow: none;
  border-radius: 6px;

  &:not(:focus).is-danger {
    border-color: #D32F2F !important;
  }

  &:disabled {
    background-color: $lightgray;
  }
}

.help.is-danger {
  color: #000!important;
  background-color: #FBEBEB;
  border: 1px solid #D32F2F;
  padding: 12px 16px;
  margin-top: 8px;
  display: block;
  border-radius: 2px;
  font-size: 1.3rem!important;
  font-weight: normal;
}

.ordered-list {
  margin: 16px 0;
  font-size: 1.8rem;
  font-weight: 700;
  line-height: 1.5;
  text-align: left;
}

p {
  text-align: left;
  font-size: 1.8rem;
}

span {
  font-weight: 700;
}

.confirmation {
  &__icon {
    display: flex;
    margin: 24px auto 16px;
    width: 30px;
    height: 30px;
    position: relative;

    &:after {
      content: "";
      position: absolute;
      display: block;
      background-image: url("https://tstabgmypagescode.blob.core.windows.net/public/drop/static/images/Email.svg");
      width: 30px;
      height: 30px;
      z-index: 5;
    }

    &:before {
      content: "";
      position: absolute;
      display: block;
      left: -9px;
      top: -9px;
      width: 48px;
      height: 48px;
      background-color: #FFD000;
      border-radius: 50%;
      z-index: 1;
    }
  }
}

.disclaimer {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #E9E9E9;

  h2 {
    font-size: 1.6rem;
    text-align: left;
  }

  p {
    font-size: 1.4rem;
    line-height: 1.5;

    &:not(:last-of-type) {
      margin-bottom: 16px;
    }
  }
}

</style>
